exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.externalRow {\n  margin-right: -25%;\n}\n.externalRow .subtitle {\n  font-weight: 500;\n  margin: 0;\n}\n.externalRow div {\n  margin: 7px 0;\n}\n.externalRow b {\n  font-weight: 500;\n}\n.externalRow span.title {\n  font-weight: 400;\n  font-size: 13px;\n  color: #78849e;\n}\n", ""]);

// exports
